import { ShieldCheck, RefreshCcw, LifeBuoy, ClipboardCheck } from "lucide-react";
import Reveal from "@/components/Reveal";

const POINTS = [
  {
    icon: LifeBuoy,
    title: "Supporto didattico concreto",
    text: "Gli insegnanti sono a disposizione degli allievi durante tutto il corso, con un supporto finalizzato agli obiettivi concordati all'inizio.",
  },
  {
    icon: ClipboardCheck,
    title: "Lezioni integrative",
    text: "Se serve, si aggiungono lezioni integrative fino al conseguimento degli obiettivi individuati insieme.",
  },
  {
    icon: RefreshCcw,
    title: "Ripeti il corso gratis",
    text: "Chi non ottiene i risultati previsti può frequentare nuovamente il corso a titolo completamente gratuito.",
  },
];

export default function GuaranteeSection() {
  return (
    <section className="relative mx-auto max-w-7xl px-5 py-24 sm:px-8" data-testid="guarantee-section">
      <Reveal>
        <div className="relative overflow-hidden rounded-[32px] border border-[#1F8296]/25 bg-gradient-to-br from-[#E8F2F4] via-white to-[#EFF6F7] p-8 sm:p-14">
          <div className="bg-grid-pattern pointer-events-none absolute inset-0 opacity-40" />
          <div className="animate-float-slow pointer-events-none absolute -right-20 -top-20 h-72 w-72 rounded-full bg-[#2997AB]/15 blur-3xl" />

          <div className="relative grid gap-12 lg:grid-cols-12">
            <div className="lg:col-span-5">
              <div className="inline-flex h-16 w-16 items-center justify-center rounded-2xl border border-[#1F8296]/40 bg-[#1F8296]/10">
                <ShieldCheck className="h-8 w-8 text-[#1F8296]" />
              </div>
              <p className="mt-7 font-script text-2xl text-[#238496]">In più, scopri anche la nostra…</p>
              <h2 className="text-balance mt-2 font-display text-3xl font-semibold tracking-tight text-[#1A2E33] sm:text-4xl">
                Garanzia di Profitto
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-[#5C7178] sm:text-base">
                La nostra promessa è semplice: il risultato concordato all'inizio del corso viene
                raggiunto. Se così non fosse, rifrequentare il corso non ti costa nulla.
              </p>
            </div>

            <div className="grid gap-4 sm:grid-cols-1 lg:col-span-7">
              {POINTS.map((p, i) => (
                <Reveal key={p.title} delay={0.08 * i}>
                  <div className="flex gap-5 rounded-2xl border border-[#D8E5E8] bg-white/80 p-6 transition-colors duration-300 hover:border-[#1F8296]/40">
                    <p.icon className="h-6 w-6 shrink-0 text-[#2997AB]" />
                    <div>
                      <h3 className="font-display text-lg font-semibold text-[#1A2E33]">{p.title}</h3>
                      <p className="mt-1.5 text-sm leading-relaxed text-[#5C7178]">{p.text}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
